import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const Man = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Man Drawing</h1>
        <p>Create a simple stick figure man with this coding project.</p>
        <div
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "300px",
            borderRadius: "18px",
            marginBottom: "18px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px auto",
          }}
        >
          <ImageWithFallback 
            src="/man.gif" 
            alt="Man Drawing" 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "18px",
            }}
          />
        </div>
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project draws a simple stick figure man using Python code and turtle graphics.</p>
        <h2>Download</h2>
        <a href="/man.py" download>Download man.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file in your local environment to see the man being drawn.</p>
      </div>
    </div>
  );
};

export default Man; 